<div class="max-w-7xl">
  <!-- Loading -->
  <div *ngIf="isLoading" class="flex justify-center py-12">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading && overview">
    <!-- Karty statystyk -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
      <!-- Użytkownicy z onboardingiem -->
      <mat-card class="!shadow-sm">
        <mat-card-content class="!p-4">
          <div class="text-sm text-gray-500 dark:text-gray-400">Ukończono onboarding</div>
          <div class="text-3xl font-bold mt-1 dark:text-white">{{ overview.totalUsersWithOnboarding }}</div>
          <div class="text-xs text-gray-400 mt-1">
            {{ overview.totalUsersWithoutOnboarding }} jeszcze nie widziało
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Oceny -->
      <mat-card class="!shadow-sm">
        <mat-card-content class="!p-4">
          <div class="text-sm text-gray-500 dark:text-gray-400">Średnia ocena</div>
          <div class="text-3xl font-bold mt-1 dark:text-white">
            {{ overview.avgRating !== null ? overview.avgRating : '—' }}
            <span class="text-lg text-amber-500" *ngIf="overview.avgRating !== null">★</span>
          </div>
          <div class="text-xs text-gray-400 mt-1">
            {{ overview.ratingCount }} ocen
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Ukończone / Pominięte -->
      <mat-card class="!shadow-sm">
        <mat-card-content class="!p-4">
          <div class="text-sm text-gray-500 dark:text-gray-400">Ukończone / Pominięte</div>
          <div class="text-3xl font-bold mt-1 dark:text-white">
            {{ overview.completedCount }} / {{ overview.skippedCount }}
          </div>
          <div class="text-xs text-gray-400 mt-1">
            z {{ overview.totalFeedbacks }} sesji
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Średnie ukończenie -->
      <mat-card class="!shadow-sm">
        <mat-card-content class="!p-4">
          <div class="text-sm text-gray-500 dark:text-gray-400">Śr. ukończenie</div>
          <div class="text-3xl font-bold mt-1 dark:text-white">{{ overview.avgCompletionPercent }}%</div>
          <div class="text-xs text-gray-400 mt-1">
            śr. {{ overview.avgStepsCompleted }} kroków
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Średni czas ukończenia -->
      <mat-card class="!shadow-sm">
        <mat-card-content class="!p-4">
          <div class="text-sm text-gray-500 dark:text-gray-400">Śr. czas ukończenia</div>
          <div class="text-3xl font-bold mt-1 dark:text-white">
            {{ overview.avgCompletionDuration ? formatDuration(overview.avgCompletionDuration) : '—' }}
          </div>
          <div class="text-xs text-gray-400 mt-1">
            użytkownicy, którzy ukończyli
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Średni czas pominięcia -->
      <mat-card class="!shadow-sm">
        <mat-card-content class="!p-4">
          <div class="text-sm text-gray-500 dark:text-gray-400">Śr. czas pominięcia</div>
          <div class="text-3xl font-bold mt-1 dark:text-white">
            {{ overview.avgSkipDuration ? formatDuration(overview.avgSkipDuration) : '—' }}
          </div>
          <div class="text-xs text-gray-400 mt-1">
            użytkownicy, którzy pominęli
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Rozkład ocen -->
    <mat-card class="!shadow-sm mb-8" *ngIf="overview.ratingCount > 0">
      <mat-card-content class="!p-4">
        <h3 class="text-lg font-semibold mb-4 dark:text-white">Rozkład ocen</h3>
        <div class="flex flex-col gap-2">
          <div *ngFor="let star of [5,4,3,2,1]" class="flex items-center gap-3">
            <span class="w-16 text-sm text-right text-gray-600 dark:text-gray-400">{{ star }} {{ star === 1 ? 'gwiazdka' : (star < 5 ? 'gwiazdki' : 'gwiazdek') }}</span>
            <div class="flex-1 h-6 bg-gray-100 dark:bg-gray-700 rounded overflow-hidden">
              <div class="h-full bg-amber-400 rounded transition-all"
                [style.width.%]="(overview.ratingDistribution[star] / getMaxRatingCount()) * 100">
              </div>
            </div>
            <span class="w-8 text-sm text-gray-500 dark:text-gray-400 text-right">{{ overview.ratingDistribution[star] }}</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Lejek przewodnika -->
    <mat-card class="!shadow-sm mb-8" *ngIf="overview.totalFeedbacks > 0">
      <mat-card-content class="!p-4">
        <h3 class="text-lg font-semibold mb-1 dark:text-white">Lejek przewodnika</h3>
        <p class="text-xs text-gray-400 mb-4">Ilu użytkowników dotarło do każdego kroku</p>

        <div class="funnel-chart">
          <!-- Oś Y -->
          <div class="funnel-y-axis">
            <span class="funnel-y-label">{{ getFunnelMax() }}</span>
            <span class="funnel-y-label">{{ Math.round(getFunnelMax() / 2) }}</span>
            <span class="funnel-y-label">0</span>
          </div>
          <!-- Słupki -->
          <div class="funnel-bars">
            <div *ngFor="let item of getFunnelSteps()" class="funnel-bar-wrapper"
              [title]="item.step + '. ' + item.name + ' — ' + item.reached + ' użytk.'">
              <div class="funnel-bar"
                [style.height.%]="(item.reached / getFunnelMax()) * 100">
              </div>
              <span class="funnel-x-label">{{ item.step }}</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Ostatnie feedbacki -->
    <mat-card class="!shadow-sm" *ngIf="feedbacks.length > 0">
      <mat-card-content class="!p-4">
        <h3 class="text-lg font-semibold mb-4 dark:text-white">Ostatnie sesje przewodnika</h3>
        <div class="overflow-x-auto">
          <table mat-table [dataSource]="feedbacks" class="w-full">
            <!-- Użytkownik -->
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef>Użytkownik</th>
              <td mat-cell *matCellDef="let f">
                <span *ngIf="f.user">{{ f.user.email }}</span>
                <span *ngIf="!f.user" class="text-gray-400">—</span>
              </td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let f">
                <span *ngIf="f.completed" class="text-green-600 dark:text-green-400 font-medium">Ukończony</span>
                <span *ngIf="!f.completed" class="text-amber-600 dark:text-amber-400 font-medium">Pominięty</span>
              </td>
            </ng-container>

            <!-- Ocena -->
            <ng-container matColumnDef="rating">
              <th mat-header-cell *matHeaderCellDef>Ocena</th>
              <td mat-cell *matCellDef="let f">
                <span class="text-amber-500">{{ getRatingStars(f.rating) }}</span>
              </td>
            </ng-container>

            <!-- Kroki -->
            <ng-container matColumnDef="steps">
              <th mat-header-cell *matHeaderCellDef>Kroki</th>
              <td mat-cell *matCellDef="let f">
                {{ f.stepsCompleted }}/{{ f.totalSteps }} ({{ f.completionPercent }}%)
              </td>
            </ng-container>

            <!-- Czas -->
            <ng-container matColumnDef="duration">
              <th mat-header-cell *matHeaderCellDef>Czas</th>
              <td mat-cell *matCellDef="let f">{{ formatDuration(f.durationSeconds) }}</td>
            </ng-container>

            <!-- Data -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Data</th>
              <td mat-cell *matCellDef="let f">{{ formatDate(f.createdAt) }}</td>
            </ng-container>

            <!-- Urządzenie -->
            <ng-container matColumnDef="device">
              <th mat-header-cell *matHeaderCellDef>Urządzenie</th>
              <td mat-cell *matCellDef="let f">
                <span class="text-xs px-2 py-0.5 rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300">{{ f.device || 'web' }}</span>
              </td>
            </ng-container>

            <!-- Akcje -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let f">
                <button mat-icon-button color="warn" (click)="deleteFeedback(f._id)" title="Usuń">
                  <mat-icon [svgIcon]="'tabler_outline:trash'" class="!w-4 !h-4"></mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Brak danych -->
    <div *ngIf="overview.totalFeedbacks === 0" class="text-center py-12">
      <mat-icon [svgIcon]="'tabler_outline:chart-bar-off'" class="!w-12 !h-12 text-gray-300 dark:text-gray-600 mb-3"></mat-icon>
      <p class="text-gray-500 dark:text-gray-400">Brak danych o przewodniku. Nikt jeszcze nie ukończył ani nie pominął przewodnika.</p>
    </div>
  </ng-container>
</div>
